module.exports = ".map-container {\n  position: relative;\n  width: 500px;\n}\n\nagm-map {\n  width: 500px;\n  height: 400px;\n  cursor: none!important;\n}\n"